import {uploadImagesService} from '@/services/uploadImages'
import {useState} from 'react'

export const useImagesUpload = () => {
  const [uploading, setUploading] = useState(false)
  const [progress, setProgress] = useState(0)
  const [uploadErrors, setUploadErrors] = useState([])
  const [isSingleImgUpload, setIsSingleImgUpload] = useState(false)
  const [prodIds, setAllProdIds] = useState([])

  const onUploadProgress = progressEvent => {
    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    setProgress(progress)
  }

  const onUploadImages = (formData, onCallback = () => {}) => {
    setUploading(true)
    uploadImagesService({formData, onUploadProgress})
      .then(response => {
        if (response?.status === 'SUCCESS') {
          onCallback(response)
          setUploading(false)
          setProgress(0)
          setIsSingleImgUpload(true)
          // setUploadErrors([])

          return
        }
        // else if (response?.status === 'PARTIAL_SUCCESS') {
        //   const itemsWithErrors = response?.data?.filter(item => item?.errors && item?.errors?.length > 0)
        //   const allErrors = itemsWithErrors?.map(item => item?.id || [])?.flat()
        //   const errMsg = `Some files were uploaded successfully. Following files could not be found or failed to upload: ${allErrors}.Please check these files and try again.`
        //   setUploadErrors([errMsg])
        // }
        else {
          const allErrors = response?.data?.flatMap(item => item?.errors || [])
          setUploadErrors(allErrors)
        }
        setUploading(false)
        setProgress(0)
      })
      .catch(error => {
        const allErrors = error?.data?.data?.flatMap(item => item?.errors || [])
        const allProdIds = error?.data?.data?.flatMap(item => item?.id || [])
        setAllProdIds(prev => [...prev, allProdIds])
        const errMsgs = isSingleImgUpload
          ? `Some files were uploaded successfully. Following files could not be found or failed to upload: ${[...prodIds]}.Please check these files and try again.`
          : allErrors
        const errMsg =
          error?.response?.data?.errorMessage ||
          error?.data?.message ||
          error?.message ||
          allErrors ||
          'An unknown error occurred'
        setUploading(false)
        setProgress(0)
        const errorMessages = Array.isArray(errMsg) ? errMsg : [errMsg]
        setUploadErrors(prev => [...prev, ...errorMessages])
      })
  }
  return {
    onUploadImages,
    uploading,
    progress,
    uploadErrors,
    setUploadErrors,
    setIsSingleImgUpload,
    setAllProdIds,
    prodIds,
  }
}
